import RateCardTableItem, { RateCardTableItemProps } from './RateCardTableItem';

export type { RateCardTableItemProps };
export default RateCardTableItem;
